'use client';

import { AppProgressBar as ProgressBar } from 'next-nprogress-bar';

const ProgressBarProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      {children}
      <ProgressBar
        height="4px"
        color="#C41719"
        // color="#000"
        options={{ showSpinner: false }}
      />
    </>
  );
};

export default ProgressBarProvider;
